import type React from 'react';

export function DetailRow({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-md px-2.5 py-2 -mx-2.5 hover:bg-black/[0.025] transition-colors">
      <div className="text-xs font-medium text-muted-foreground mb-1.5">
        {label}
      </div>
      <div>{children}</div>
    </div>
  );
}
